jQuery(document).ready(function ($) {
    $(".zggtheme-carousel").each(function () {

        const $carouselWrapper = $(this)
        const $contentWrapper = $(this).find(".zggtheme-carousel-wrapper")
        const $items = $contentWrapper.children().map(function() {
            return $(this);
        });

        const $buttons = [ // 0 Previous, 1 Next
                $(this).find('.carousel-button-prev'),
                $(this).find('.carousel-button-next')]

        const buttonsVisible = [true, true]

        const slideDuration = 2
        const speedReductionFixed = 1/slideDuration
        const slideFactorOnLetGo = 25
        const slideFactorOnArrow = 6

        let speed = 0
        let scroll = 0
        let visScroll = scroll

        let touchStart = 0
        let touchStartY = 0
        let touch = 0
        let touchY = 0
        let scrollIntent = null

        let isDragging = false
        let isArrow = false
        let isWheeling = 0
        let animationActive = false
        let moved = 100
        let arrowClicked = 0
        let referringTimeout = 0

        let itemWidth = 0
        let carouselWrapperWidth = 0
        let contentWidth = 0
        let rightMaxScroll = 0;

        const maxOverscroll = 80            // max. visuelle Dehnung in px (Gefühl)
        const returnStiffness = 2      // Federstärke beim Zurückfedern (0..1)
        const stopStiffness = 0.1
        const returnDamping = 0.75        // Dämpfung pro Frame (0..1)
        const edgeStopSnap = 0.9         // Snap-Grenze
        const speedStopSnap = 0.3

        function rubberBand(distance, relaxPos, overscroll = maxOverscroll) {
            const distanceCorrected = distance - relaxPos
            return relaxPos + (overscroll * distanceCorrected) / (Math.abs(distanceCorrected) + overscroll);
        }

        function lerp(a, b, t) { return a + (b - a) * t; }

        const dispose = function () {
            /*
            for (let i = 0; i < itemsPerMenu[activeMenu].length; i++) {
                itemsPerMenu[activeMenu][i].css("left", (i * itemWidth[activeMenu] + scroll) + "px")
            }
            */
            if ((visScroll <= 0) === (visScroll >= rightMaxScroll)) $contentWrapper.css("transform", "translateX(" + visScroll + "px)")
            else if (visScroll > 0) {
                $contentWrapper.css("transformOrigin", "left center")
                $contentWrapper.css("transform", "scaleX(" + (1+visScroll/maxOverscroll/20) + ") translateX(" + 0 + "px)")
            }
            else if (visScroll < rightMaxScroll) {
                $contentWrapper.css("transformOrigin", "left center")
                $contentWrapper.css("transform", "scaleX(" + (1+Math.abs(visScroll-rightMaxScroll)/maxOverscroll/20) + ") translateX(" + (rightMaxScroll - carouselWrapperWidth * (Math.abs(visScroll-rightMaxScroll)/maxOverscroll/20)) + "px)")
            }
        };

        const hideButton = function (buttonNum) {
            if (buttonsVisible[buttonNum]) {
                $buttons[buttonNum].addClass('invisible')
                buttonsVisible[buttonNum] = false
            }
            //console.log(buttonsVisible[buttonNum])
        }

        const showButton = function (buttonNum) {
            if (!buttonsVisible[buttonNum]) {
                $buttons[buttonNum].removeClass('invisible')
                buttonsVisible[buttonNum] = true
            }
        }

        const calcSpeed = function(dist, slideFactor = 1) {
            speed += dist / slideDuration / slideFactor
        }

        const dispatchSpeed = function (dist, slideFactor = 1) {
            calcSpeed(dist, slideFactor)

            showButton(0)
            showButton(1)

            if (!animationActive) {
                animationActive = true
                requestAnimationFrame(render)
            }
        }

        const moveSpeed = function () {

            let stopRange = true;

            if (contentWidth < carouselWrapperWidth) {
                visScroll = scroll = (carouselWrapperWidth - contentWidth) / 2
                speed = 0
                hideButton(0)
                hideButton(1)
                return true
            }

            let speedReduction = speedReductionFixed

            scroll += speed
            visScroll = scroll

            if (scroll > 0 || scroll < rightMaxScroll) {
                const side = (scroll > 0) ? 0 : 1 // 0: left side overflow, 1 right side overflow
                const relaxPos = rightMaxScroll * side

                if (side) hideButton(1)
                else hideButton(0)
                
                if (arrowClicked) {
                    referringTimeout += 1
                    setTimeout(() => { referringTimeout -= 1; }, 400)
                }

                if (isDragging || isWheeling) {
                    
                    visScroll = rubberBand(scroll, relaxPos) //relaxPos = 0 on left overflow and rightMaxScroll
                    
                } else {
                    let stiffness = returnStiffness

                    if (Math.sign(speed) === Math.sign(scroll)) {
                        speedReduction = 0
                        stiffness = stopStiffness
                    }
                    else {
                        speedReduction = returnDamping
                    }

                    const spring = - stiffness * (scroll - relaxPos)
                    calcSpeed(spring)

                    visScroll = rubberBand(scroll, relaxPos)
                    
                    if (Math.abs(scroll - relaxPos) > edgeStopSnap || Math.abs(speed) > speedStopSnap) {
                        stopRange = false
                    }
                    else {
                        visScroll = scroll = relaxPos
                        speed = 0
                    }
                }
            }
            else if (isArrow) {
                speedReduction = speedReduction/slideFactorOnArrow
            }
            else if (!isDragging) {
                speedReduction = speedReduction/slideFactorOnLetGo
            }

            if (isWheeling) {
                isWheeling--
            }

            if (Math.abs(speed) > speedStopSnap) {
                stopRange = false
            }

            speed = speed * (1-speedReduction)

            return stopRange;
        }

        const handleMouseWheel = function (event) {
            //console.log(-e.originalEvent.deltaY)
            //console.log(-e.originalEvent.deltaX)

            if (event.originalEvent.deltaX !== 0) {
                dispatchSpeed(-event.originalEvent.deltaX * 1.5, slideFactorOnLetGo)
                event.preventDefault();
                isArrow = false
                isWheeling = 2
            }
            else if (event.originalEvent.shiftKey) {
                dispatchSpeed(-event.originalEvent.deltaY * 1.5, slideFactorOnLetGo)
                event.preventDefault();
                isArrow = false
                isWheeling = 2
            }
        };

        const handleTouchStart = function (e) {
            let evt = e.originalEvent || e;
            touchStart = evt.touches && evt.touches.length ? evt.touches[0].clientX : (evt.clientX || 0);
            touchStartY = evt.touches && evt.touches.length ? evt.touches[0].clientY : (evt.clientY || 0);

            isDragging = true
            moved = 0
            isArrow = false
            scrollIntent = null
        };

        const handleTouchMove = function (event) {
            moved += 1;

            if (!isDragging) return;

            let evt = event.originalEvent || event;
            touch = evt.touches && evt.touches.length ? evt.touches[0].clientX : (evt.clientX || 0);
            touchY = evt.touches && evt.touches.length ? evt.touches[0].clientY : (evt.clientY || 0);

            if (scrollIntent === null) {
                let dx = Math.abs(touch - touchStart);
                let dy = Math.abs(touchY - touchStartY);
                if (dx > 5 || dy > 5) {
                    if (dx > dy) {
                        scrollIntent = 'horizontal';
                    } else {
                        scrollIntent = 'vertical';
                    }
                } else {
                    return; // Noch nicht genug bewegt, um Intent festzustellen
                }
            }

            if (scrollIntent === 'vertical') {
                return; // Normales vertikales Scrollen zulassen
            }

            // Horizontales Scrollen: Browser-Default unterdrücken (verhindert Bouncen/Refresh)
            if (event.cancelable !== false) {
                event.preventDefault();
            }

            dispatchSpeed((touch - touchStart))
            touchStart = touch;
            touchStartY = touchY;
        };


        const handleTouchEnd = function () {
            isDragging = false
        };

        const shouldArrowClickReturn = function (event) {
            if (scrollIntent !== null || moved > 5) {
                return true
            }

            arrowClicked += 1
            setTimeout(function () {
                arrowClicked -= 1
            }, 200)
        }

        const handlePrevArrowClick = function (event) {
            if (shouldArrowClickReturn(event)) return

            isArrow = true
            dispatchSpeed(Math.min(carouselWrapperWidth/1.5, itemWidth*2), slideFactorOnArrow)
        }

        const handleNextArrowClick = function (event) {
            if (shouldArrowClickReturn(event)) return

            isArrow = true
            dispatchSpeed(-Math.min(carouselWrapperWidth/1.5, itemWidth*2), slideFactorOnArrow)
        }

        const handleResizeWindow = function () {

            itemWidth = 0
            let itemCount = 0

            $.each($items, function () {
                itemWidth = $(this).outerWidth(true)
                itemCount++
            })

            contentWidth = itemCount * itemWidth + parseInt($contentWrapper.css("padding-left")) + parseInt($contentWrapper.css("padding-right"))
            carouselWrapperWidth = $carouselWrapper.outerWidth();
            rightMaxScroll = carouselWrapperWidth - contentWidth;

            //$contentWrapper.css("width", contentWidth)

            if (contentWidth > carouselWrapperWidth) {
                showButton(0)
                showButton(1)
            }
            else {
                hideButton(0)
                hideButton(1)
            }

            dispatchSpeed(0)
        }

        const handleTouchItemEnd = function (event) {
            if (scrollIntent !== null || moved > 5) {
                return
            }

            if (referringTimeout) {
                return
            }

            window.location = encodeURI($(this).attr("href"))
        };

        $(this)
            .on('wheel', handleMouseWheel)
            .on('touchstart', handleTouchStart)
            .on('touchmove', handleTouchMove)
            .on('touchend', handleTouchEnd)
            .on('mousedown', handleTouchStart)
            .on('mousemove', handleTouchMove)
            .on('mouseleave', handleTouchEnd)
            .on('mouseup', handleTouchEnd)
            .on('selectstart', function () {
                return false;
            });

        $buttons[0]
            .on('mouseup', handlePrevArrowClick)

        $buttons[1]
            .on('mouseup', handleNextArrowClick)

        $(window).on('resize', handleResizeWindow);

        $items.each(function(index, item) {
            item.on('mouseup', handleTouchItemEnd)
                .on('touchend', handleTouchItemEnd)
        });

        // Render code
        const render = function () {
            //console.log(activeMenu)

            let stop = moveSpeed()

            dispose()

            //console.log(stop)

            if (!isDragging && stop) {
                isArrow = false
                isWheeling = 0
                animationActive = false
                speed = 0
                return;
            }

            //console.log(speed)

            requestAnimationFrame(render)

            //console.log(y)
            //console.log(scroll[activeMenu], y[activeMenu])
        };

        handleResizeWindow()
        hideButton(0)
    })
});